
import Vue from 'vue'
import Component from 'vue-class-component';
import EventBus from '../../eventBus'
import { required } from 'vuelidate/lib/validators'
import { Validations } from 'vuelidate-property-decorators';
import Currencies from '../../utils/Currencies'

@Component
export default class Currency extends Vue {
    @Validations()
    validations = {
        currency: {
            name: { required },
            symbol: { required },
        }
    }
    private error: string = '';
    private activeScreen: string = 'loading';
    private additionalSuccessMessage: string = '';
    private successMessage: string = '';
    private loadingMessage: string = '';
    private loadingTitle: string = '';

    private currency: any = {
        name:"",
        symbol:"",
        conversionFactors:[]
    };
    private search: string = '';
    private title: string = '';
    private deletePromptProperty: boolean = false;
    private activeItem: any = {};
    private isEdit : boolean = false;
    private fields: any[] = [
        { key: 'name', label: 'Name'},
        { key: 'symbol', label: 'Code'},
        { key: 'sign', label: 'Symbol'},
        { key: 'button', label: 'Actions'},
    ];

    private Currencies = Currencies

    private get getAllCurrencies () {
        return this.$store.getters['CurrencyModule/getAllCurrencies'];
    }

    private fetchCurrencies () {
        return this.$store.dispatch('CurrencyModule/fetchCurrencies')
    }

    private searchValue (e: any) {
        this.search = e;
    }

    private openForm() {
        this.currency = {
            name:"",
            symbol:"",
            conversionFactors:[]
        }
        let formModal = this.$refs.budget as any;
        this.title = 'Create New Budget Line';
        formModal.show();
    }

    private deleteCurrency() {
        this.activeScreen = 'loading'
        this.loadingMessage = 'Please wait while we delete this currency'
        this.loadingTitle = 'Deleting...'
        EventBus.$emit('activeScreen', this.activeScreen)
        this.$store.dispatch('CurrencyModule/deleteCurrency', this.activeItem).then(response => {
            this.activeScreen = 'successNoBack'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.additionalSuccessMessage = 'This currency will no longer be available'
            this.successMessage = this.currency.name + ' Deleted Successfully'
            this.deletePromptProperty = false
        }, error => {          
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
            this.deletePromptProperty = false
        })
    }

    save() {
        this.loadingMessage = 'Please wait while we save this currency';
        this.loadingTitle = 'Saving currency';
        this.$store.dispatch('currency/createCurrency', this.currency)
        .then((response: any) => {
            this.activeScreen = 'successNoBack';
            EventBus.$emit('activeScreen', this.activeScreen);
            this.additionalSuccessMessage = '';
            this.successMessage = 'Successfully Created currency: '+ this.currency.name;
        }). catch((error: any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
        })
    }

    updateCurrency() {
        this.$store.dispatch('currency/updateCurrency', this.currency)
        .then((response: any) => {
            this.loadingMessage = 'Please wait while we update this currency';
            this.loadingTitle = 'Updating currency';
            this.activeScreen = 'successNoBack';
            EventBus.$emit('activeScreen', this.activeScreen);
            this.additionalSuccessMessage = '';
            this.successMessage = 'Currency Updated Successfully';
        }).catch((error:any) => {
            this.activeScreen = 'error'
            EventBus.$emit('activeScreen', this.activeScreen)
            this.error = error.message
        })
    }

    private saveCurrency () {
        this.activeScreen = 'loading';
        EventBus.$emit('activeScreen', this.activeScreen);
        if (this.isEdit === false ){
            this.save()
        } else {
            this.updateCurrency()
        }        
    }

    private update(data: any) {
        this.isEdit = true;
        this.currency = data;
        let formModal = this.$refs.budget as any;
        this.title = 'Update Currency';
        formModal.show();
    }

    private promptDelete(e: any) {
        this.activeItem = e;
        this.deletePromptProperty = true;
    }

    created () {
        this.loadingMessage = 'Loading Currencies';
        this.loadingTitle = 'Loading...';
        if (this.getAllCurrencies.length == 0) {
            this.fetchCurrencies().then((res: any) => {
                this.activeScreen = 'main'
                EventBus.$emit('activeScreen', this.activeScreen)
            })
        } else {
            this.activeScreen = 'main'
            EventBus.$emit('activeScreen', this.activeScreen)
        }
    }
}
